import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StoreService } from '../store.service';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';

@Component({
	selector: 'app-create-supplier',
	templateUrl: './create-supplier.component.html',
	providers: [ApiService, ConfirmationService],
	encapsulation: ViewEncapsulation.None
})

export class CreateSupplierComponent implements OnInit {
	loadingMessage: string = "Creating Supplier...";
	userform: FormGroup;


	msgs: Message[] = [];


	constructor(private router: Router, private api: ApiService,
		private spinner: NgxSpinnerService, private confirmationService: ConfirmationService, private ss: StoreService,
		private fb: FormBuilder) { }

	ngOnInit() {

		this.onloadgroup();

	}

	onloadgroup() {
		this.userform = this.fb.group({
			'FullName': new FormControl(''),
			'Addr1': new FormControl(''),
			'Addr2': new FormControl(''),
			'Addr3': new FormControl(''),
			'Ship_City': new FormControl(''),
			'State': new FormControl(''),
			'Ship_Country': new FormControl(''),
			'Ship_PostalCode': new FormControl(''),
			'PrimaryPhone': new FormControl(''),
			'PrimaryEmailAddr': new FormControl(''),
			'Fax': new FormControl(''),
			'JobDesc': new FormControl(''),
			'TaxIdentifier': new FormControl(''),

			

		});
	}


	onSubmit(value: string) {


		this.msgs = [];

		 if(this.userform.value.FullName ===null || this.userform.value.FullName ==="" )
		 {
			this.msgs.push({ severity: 'info', summary: 'Mandatory ....', detail: "Please enter Company Name" });
			return;
		 }

		if (this.userform.valid) {
			this.spinner.show();
			this.api.post('Rah/CreateNewSupplier', value).subscribe(
				(res: {}) => this.sucess(res),
				error => this.faild(<any>error));
		}
	}

	sucess(resp: any) {
		this.msgs = [];
		this.spinner.hide();
		

		if (resp.Success == null) {
			this.msgs.push({ severity: 'error', summary: 'Failed To Sync Company', detail: resp.Message });
			return;
		}

		if (resp.Message == "Unauthorized") {
			this.msgs.push({ severity: 'error', summary: 'Failed To Sync Company', detail: "We are not able to connect Please Reconnect your company from switch company menu" });
			return;
		}

		if (resp.Success == true) {
			this.getVendor();
			this.msgs.push({ severity: 'info', summary: 'success.', detail: "Supplier is created successfully.." });
			this.onloadgroup();
		}

	}

	faild(resp: any) {
		this.msgs = [];
		this.spinner.hide();
		this.msgs.push({ severity: 'error', summary: 'Failed To Create Supplier', detail: "Supplier is not created.." });
	}


	getVendor() {
		this.spinner.show();
		this.loadingMessage = "Get Vendor...";
		this.api.get('Rah/GetAllQboVendor', '').subscribe(
			(res: {}) => this.success_getVendor(res),
			error => this.failed_getVendor(<any>error));
	}

	success_getVendor(resp: any) {

		console.log("getVendor")
		console.log(resp.Data)
		this.spinner.hide();
		this.ss.storeQboVendors(resp.Data);
	}

	failed_getVendor(resp: any) {
		this.spinner.hide();
	}

}